export default __webpack_public_path__ + "static/media/glaze_lily.6741ff24.png";